import { ChangeDetectionStrategy, Component, effect, inject, input, resource } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResourceWrapperComponent, RisrHeaderCard, RisrHeaderCardTitle,setPageTitle } from '@fry-it/risr-core';
import { ReportStore } from '../../services/report-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { ReportRun } from '../../components/report-run/report-run';

@Component({
  selector: 'risr-reports-run-page',
  imports: [
    RisrHeaderCardTitle,
    RisrHeaderCard,
    ResourceWrapperComponent,
    ReportRun
  ],
  templateUrl: './report-run-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportRunPage {
    readonly reportId = input.required<string>();

    private reportStore = inject(ReportStore);
    private route = inject(ActivatedRoute);
    $remoteUser = toSignal(this.route.paramMap.pipe(map(params => params.get('user') || '__own__')));

    reportResource = resource({
      params: this.reportId ?? undefined,
      loader: ({ params }) => this.reportStore.get(params)
    });

    constructor() {
      effect(() => {
        const report = this.reportResource.value();
        if (report?.name) {
          setPageTitle($localize`Run report` + ' - ' + report.name);
        }
      });
    }
 }
